

import React from 'react';
import CountryTable from '../../components/CountryTable';
import Layout from '../../components/Layout';
import { getUserInfo } from '../../user';
import { Navigate } from 'react-router-dom';

export default function Country() {
  const [user, setUser] = React.useState(null);
  React.useEffect(() => {
    getUserInfo().then(setUser);
  }, []);
  if (!user) return null;
  if (!Array.isArray(user.roles) || !user.roles.includes('admin')) return <Navigate to="/" replace />;
  return ( 
    <Layout> 
      <h1 className="text-2xl font-bold mb-4">Countries</h1> 
      <CountryTable /> 
    </Layout> 
  ); 
}
